function tabsInit() {
  const tabNavs = document.querySelectorAll('[data-tab-nav]');
  const rightKeyCode = 39;
  const leftKeyCode = 37;

  if (tabNavs === null) { return; }

  tabNavs.forEach(tabNav => {
    const tabs = tabNav.querySelectorAll('[data-tab]');
    const tabNavType = tabNav.getAttribute('data-tab-nav');
    const tabContentWraps = document.querySelectorAll(`[data-tab-content-wrap="${tabNavType}"]`);

    if (tabs === null || tabContentWraps === null) { return; }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => handleTabChange(tab, tabs, tabContentWraps));
      tab.addEventListener('focus', () => handleTabChange(tab, tabs, tabContentWraps));
    });

    // Enable arrow navigation between tabs in the tab list
    let tabFocus = 0;

    // eslint-disable-next-line shopify/prefer-early-return
    tabNav.addEventListener('keydown', event => {
      if (event.keyCode === rightKeyCode || event.keyCode === leftKeyCode) {
        tabs[tabFocus].setAttribute('tabindex', -1);
        // Move right
        if (event.keyCode === rightKeyCode) {
          tabFocus++;
          // If we're at the end, go to the start
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
        // Move left
        } else if (event.keyCode === leftKeyCode) {
          tabFocus--;
          // If we're at the start, move to the end
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }

        tabs[tabFocus].setAttribute('tabindex', 0);
        tabs[tabFocus].focus();
      }
    });
  });

  function handleTabChange(tab, tabs, tabContentWraps) {
    if (tab.classList.contains('active')) { return; }

    const tabIndex = tab.getAttribute('data-tab');
    tabs.forEach(otherTab => {
      otherTab.classList.remove('active');
      tab.setAttribute('aria-selected', false);
    });
    tab.classList.add('active');
    tab.setAttribute('aria-selected', true);

    tabContentWraps.forEach(tabContentWrap => {
      const tabMatchingContent = tabContentWrap.querySelector(`[data-tab-content="${tabIndex}"]`);
      const activeTabContent = tabContentWrap.querySelector('[data-tab-content].active');

      activeTabContent.classList.remove('active');
      activeTabContent.setAttribute('hidden', '');
      tabMatchingContent.removeAttribute('hidden');
      tabMatchingContent.classList.add('active');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  tabsInit();
});

// rewards js 


function checkSmileLoaded() {
  const smileLoaded = setInterval(() => {
    if (!window.Smile) { return; }
    clearInterval(smileLoaded);
    rewardsPointsInit();
  }, 100);

  const smileUiLoaded = setInterval(() => {
    if (!window.SmileUI) { return; }
    clearInterval(smileUiLoaded);
    smileUiButtonsInit();
  }, 100);
}

async function rewardsPointsInit() {
  const smile = await Smile.ready();
  const spendProducts = await smile.fetchAllPointsProducts();
  const tabContent = document.querySelector('[data-tab-content="spend"]');
  const tabGrid = tabContent.querySelector('[data-rewards-points-grid]');
  const boxTemplate = tabContent.querySelector('[data-reward-points-template]');
  const bkt = boxTemplate.content.querySelector('[data-reward-points-bkt]');

  // Spend options
  spendProducts.forEach(product => {
    const newBkt = document.importNode(bkt, true);
    const boxPoints = newBkt.querySelector('[data-reward-box-points]');
    const boxPointsText = newBkt.querySelector('[data-reward-box-points-text]');
    const boxSubline = newBkt.querySelector('[data-reward-box-subline]');

    let pointVal = product.exchange_description.substr(0, product.exchange_description.indexOf(' '));
    pointVal = convertNum(pointVal);

    boxPoints.innerHTML = pointVal;
    boxPointsText.innerHTML = product.exchange_description.substr(product.exchange_description.indexOf(' ') + 1);
    boxSubline.innerHTML = product.reward.name;
    tabGrid.appendChild(newBkt);
  });

  setTimeout(() => {
    swiperInit();
  }, 50);
}

function convertNum(value) {
  let smaller = value;
  if (value >= 1000000) {
    smaller = `${value/1000000}m`;
  } else if (value >= 1000) {
    smaller = `${value/1000}k`;
  }
  return smaller;
}

function smileUiButtonsInit() {
  const smileUiContainer = document.querySelector('#smile-ui-container');
  const referLinks = document.querySelectorAll('[data-smile-deep-link]');
  if (!referLinks) { return; }

  referLinks.forEach(referLink => {
    referLink.addEventListener('click', () => {
      smileUiContainer.classList.add('show');
    });
  });
}

function swiperInit() {
  const swiperEls = document.querySelectorAll('[data-swiper-container]');
  if (!swiperEls) { return; }

  swiperEls.forEach(swiperEl => {
    const parentContent = swiperEl.closest('[data-tab-content]');

    const options = {
      slidesPerView: 'auto',
      centeredSlides: false,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
        eventsTarget: `#${swiperEl.id}`,
        invert: true,
      },
    };

    let mySwiper = null;
    const breakpoint = window.matchMedia('(min-width: 1345px)');

    function breakpointChecker() {
      if (breakpoint.matches === true && mySwiper !== null) {
        mySwiper.destroy(true, true);
        mySwiper = null;
      } else if (breakpoint.matches === false && mySwiper === null) {
        parentContent.classList.add('swiper-init');
        setTimeout(() => {
          mySwiper = new Swiper(swiperEl, options);
          parentContent.classList.remove('swiper-init');
        }, 250);
      }
    }

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  checkSmileLoaded();
});
